import type { AccountSubtype, ProductType } from '@shared/products-types';
import type { ProductWithHelpers } from '@shared/products-core';

export type ProductTypeOrSubtype = ProductType | AccountSubtype;

export enum ProductCategory {
    TOP_PRODUCTS = 'TOP_PRODUCTS',
    CURRENT = 'CURRENT',
    CARDS = 'CARDS',
    SAVINGS = 'SAVINGS',
    BUILDING_SOCIETY = 'BUILDING_SOCIETY',
    LOANS = 'LOANS',
    SECURITIES = 'SECURITIES',
    INSURANCE = 'INSURANCE',
    PENSION = 'PENSION',
    OTHER = 'OTHER',
}

export interface ProductsInCategory {
    category: ProductCategory;
    products: ProductWithHelpers[];
}
